import StudentForm from '../pages/StudentForm';
import Application from '../pages/Application';
import Login from '../pages/Login';
import SingleApplicationView from '../components/application/SingleApplicationView';
import SuccessPage from '../components/payment/SuccessPage';
import PaymentPage from '../components/payment/PaymentPage';
import ThankYouPage from '../components/payment/ThankYouPage';
import PaymentFailedPage from '../components/payment/PaymentFailedPage';
import PaymentPendingPage from '../components/payment/PaymentPendingPage';

const routes = [
    {
        path: '/',
        element: <StudentForm />,
        exact: true
    },
    {
        path: '/login',
        element: <Login />,
        exact: true
    },
    {
        path: '/payment-response',
        element: <SuccessPage />,
        exact: true
    },
    {
        path: '/thank-you',
        element: <ThankYouPage />,
        exact: true
    },
    {
        path: '/payment-failed',
        element: <PaymentFailedPage />,
        exact: true
    },
    {
        path: '/payment-pending',
        element: <PaymentPendingPage />,
        exact: true
    },
    {
        path: '/payment',
        element: <PaymentPage />,
        exact: true
    },
    {
        path: '/applications',
        element: <Application />,
        exact: true,
        requiresAuth: true
    },
    {
        path: '/applications/:id',
        element: <SingleApplicationView />,
        exact: true,
        requiresAuth: true
    }

];

export default routes;